var _path, _path2, _path3, _path4, _path5, _path6, _path7, _mask, _g, _mask2, _g2, _path8, _path9, _path0, _path1, _path10, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _rect, _path11, _rect2, _rect3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuildModule(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 166,
    viewBox: "0 0 182 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0.5H180C180.828 0.5 181.5 1.17157 181.5 2V142.197C181.5 142.584 181.351 142.955 181.084 143.234L160.229 165.037C159.946 165.333 159.555 165.5 159.145 165.5H2C1.17157 165.5 0.5 164.828 0.5 164V2C0.5 1.17157 1.17157 0.5 2 0.5Z",
    stroke: "#1A171B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.119 35.75C149.797 35.75 149.644 36.051 149.644 36.4003C149.644 36.7497 149.803 37.0077 150.125 37.0077C150.489 37.0077 150.647 36.7336 150.647 36.4165C150.647 36.0563 150.51 35.75 150.119 35.75ZM149.417 39.0073V38.3354C150.183 38.2924 150.51 37.8033 150.632 37.3303C150.452 37.5345 150.262 37.6151 149.945 37.6151C149.459 37.6151 149 37.2173 149 36.4434C149 35.5887 149.47 35.1265 150.156 35.1265C150.806 35.1265 151.292 35.5672 151.292 36.6476C151.292 37.9322 150.732 38.9051 149.417 39.0073Z",
    fill: "#1A171B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.689 35.7526V38.779H153.061V35.7526H152.333V35.1265H154.417V35.7526H153.689Z",
    fill: "#1A171B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.333 38.779V35.1265H157.863V38.1425H158.792V38.779H157.333Z",
    fill: "#1A171B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.34 36.9736C161.283 36.6918 161.207 36.2692 161.183 36.0866C161.159 36.2744 161.092 36.6657 161.03 36.9632L160.939 37.4068H161.431L161.34 36.9736ZM161.717 38.779L161.56 38.0172H160.81L160.653 38.779H160.042L160.896 35.1265H161.479L162.333 38.779H161.717Z",
    fill: "#1A171B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.723 37.1093H164.406V38.1789H164.743C165.1 38.1789 165.251 37.965 165.251 37.6624C165.251 37.2814 165.09 37.1093 164.723 37.1093ZM164.748 35.7265H164.406V36.5248H164.763C165.07 36.5248 165.165 36.337 165.165 36.1283C165.165 35.8778 165.055 35.7265 164.748 35.7265ZM164.707 38.779H163.792V35.1265H164.743C165.387 35.1265 165.789 35.4969 165.789 36.1022C165.789 36.41 165.639 36.6918 165.357 36.817C165.639 36.9318 165.875 37.198 165.875 37.6467C165.875 38.398 165.462 38.779 164.707 38.779Z",
    fill: "#1A171B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.956 39.0073C167.483 39.0073 167.155 38.7386 166.917 38.416L167.339 37.9269C167.548 38.2172 167.772 38.3569 167.981 38.3569C168.239 38.3569 168.369 38.201 168.369 37.9484C168.369 37.7334 168.244 37.5614 167.837 37.3356C167.319 37.0453 167.006 36.7605 167.006 36.137C167.006 35.5726 167.394 35.1265 167.981 35.1265C168.413 35.1265 168.682 35.3146 168.93 35.664L168.518 36.1101C168.314 35.8629 168.204 35.7769 167.966 35.7769C167.767 35.7769 167.638 35.9166 167.638 36.1047C167.638 36.3305 167.757 36.4703 168.135 36.6907C168.736 37.04 169 37.298 169 37.9322C169 38.5558 168.602 39.0073 167.956 39.0073Z",
    fill: "#1A171B"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 153,
    y: 15,
    width: 6,
    height: 5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.377 15.6143H158.794L158.791 19.9508H153.377V15.6143Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.228 20.6901L158.039 20.423L164.548 14.8745L164.737 15.1411L158.228 20.6901Z",
    fill: "#1A171B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.441 20.6901L157.251 20.423L163.761 14.8745L163.95 15.1411L157.441 20.6901Z",
    fill: "#1A171B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.653 20.6901L156.464 20.423L162.973 14.8745L163.163 15.1411L156.653 20.6901Z",
    fill: "#1A171B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.866 20.6898L155.677 20.4232L162.186 14.8745L162.375 15.1411L155.866 20.6898Z",
    fill: "#1A171B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.079 20.6898L154.89 20.4232L161.398 14.8745L161.588 15.1411L155.079 20.6898Z",
    fill: "#1A171B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.292 20.6898L154.102 20.4232L160.611 14.8745L160.8 15.1411L154.292 20.6898Z",
    fill: "#1A171B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.504 20.6898L153.314 20.4232L159.823 14.8745L160.013 15.1411L153.504 20.6898Z",
    fill: "#1A171B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.717 20.6898L152.528 20.4232L159.036 14.8745L159.226 15.1411L152.717 20.6898Z",
    fill: "#1A171B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.93 20.6898L151.74 20.4232L158.249 14.8745L158.438 15.1411L151.93 20.6898Z",
    fill: "#1A171B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.143 20.6898L150.953 20.4232L157.462 14.8745L157.651 15.1411L151.143 20.6898Z",
    fill: "#1A171B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.355 20.6898L150.166 20.4232L156.674 14.8745L156.864 15.1411L150.355 20.6898Z",
    fill: "#1A171B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.568 20.6898L149.379 20.4232L155.887 14.8745L156.077 15.1411L149.568 20.6898Z",
    fill: "#1A171B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.781 20.6898L148.592 20.4232L155.1 14.8745L155.289 15.1411L148.781 20.6898Z",
    fill: "#1A171B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.994 20.6898L147.804 20.4232L154.313 14.8745L154.502 15.1411L147.994 20.6898Z",
    fill: "#1A171B"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 153,
    y: 8,
    width: 16,
    height: 6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.377 8.89783H168.794V13.2348H153.377V8.89783Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.887 8.16479L174.396 13.9418L174.202 14.2045L167.693 8.42752L167.887 8.16479Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.1 8.16479L173.609 13.9418L173.415 14.2045L166.906 8.42752L167.1 8.16479Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.312 8.16479L172.822 13.9418L172.627 14.2045L166.118 8.42752L166.312 8.16479Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.525 8.16479L172.034 13.9418L171.84 14.2045L165.331 8.42752L165.525 8.16479Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.738 8.16479L171.247 13.9418L171.053 14.2045L164.543 8.42752L164.738 8.16479Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.95 8.16479L170.459 13.9418L170.265 14.2045L163.756 8.42752L163.95 8.16479Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.163 8.16479L169.672 13.9418L169.478 14.2045L162.969 8.42752L163.163 8.16479Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.376 8.16479L168.885 13.9418L168.691 14.2045L162.181 8.42752L162.376 8.16479Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.588 8.16479L168.097 13.9418L167.903 14.2045L161.394 8.42752L161.588 8.16479Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.801 8.16479L167.31 13.9418L167.116 14.2045L160.607 8.42752L160.801 8.16479Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.014 8.16479L166.523 13.9418L166.329 14.2045L159.819 8.42752L160.014 8.16479Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.226 8.16479L165.735 13.9418L165.541 14.2045L159.032 8.42752L159.226 8.16479Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.439 8.16479L164.948 13.9418L164.754 14.2045L158.245 8.42752L158.439 8.16479Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.651 8.16479L164.161 13.9418L163.966 14.2045L157.457 8.42752L157.651 8.16479Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.67 8.42752L156.864 8.16479L163.373 13.9418L163.179 14.2045L156.67 8.42752Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.077 8.16479L162.586 13.9418L162.392 14.2045L155.883 8.42752L156.077 8.16479Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.29 8.16479L161.799 13.9418L161.604 14.2045L155.095 8.42752L155.29 8.16479Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.502 8.16479L161.011 13.9418L160.817 14.2045L154.308 8.42751L154.502 8.16479Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.715 8.16479L160.224 13.9418L160.03 14.2045L153.521 8.42751L153.715 8.16479Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.928 8.16479L159.437 13.9418L159.242 14.2045L152.734 8.42751L152.928 8.16479Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.141 8.16479L158.649 13.9418L158.455 14.2045L151.947 8.42751L152.141 8.16479Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.353 8.16479L157.862 13.9418L157.667 14.2045L151.159 8.42751L151.353 8.16479Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.566 8.16479L157.075 13.9418L156.88 14.2045L150.372 8.42751L150.566 8.16479Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.779 8.16479L156.287 13.9418L156.093 14.2045L149.585 8.42751L149.779 8.16479Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.992 8.16479L155.5 13.9418L155.306 14.2045L148.797 8.42751L148.992 8.16479Z",
    fill: "#1A1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.204 8.16479L154.713 13.9418L154.519 14.2045L148.01 8.42751L148.204 8.16479Z",
    fill: "#1A1919"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.377 8.89783L149.104 12.9096C149.038 12.971 149 13.0612 149 13.1561V15.6926C149 15.7873 149.038 15.8775 149.104 15.9389L153.377 19.9507V8.89783Z",
    fill: "#1A171B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.794 28.9651H163.423V19.9383C163.423 19.8411 163.383 19.7497 163.315 19.6881L158.794 15.6139V28.9651Z",
    fill: "#1A171B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.419 13.2348H153.377V8.89783H154.419V13.2348Z",
    fill: "url(#paint0_linear)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.377 19.9507H154.419V15.6195L153.377 15.6143V19.9507Z",
    fill: "url(#paint1_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.794 19.9507H157.752V15.6143H158.794V19.9507Z",
    fill: "url(#paint2_linear)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 44.5,
    x2: 182,
    y2: 44.5,
    stroke: "black"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 68.5,
    x2: 120,
    y2: 68.5,
    stroke: "black"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: 131.5,
    x2: 182,
    y2: 131.5,
    stroke: "black"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: 46.5,
    x2: 182,
    y2: 46.5,
    stroke: "black"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 70.5,
    x2: 110,
    y2: 70.5,
    stroke: "black"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: 133.5,
    x2: 182,
    y2: 133.5,
    stroke: "black"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 134.5,
    y1: 2.18557e-8,
    x2: 134.5,
    y2: 45,
    stroke: "black"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 136.5,
    y1: 2.18557e-8,
    x2: 136.5,
    y2: 45,
    stroke: "black"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 134.5,
    y1: 47,
    x2: 134.5,
    y2: 131,
    stroke: "black"
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 136.5,
    y1: 47,
    x2: 136.5,
    y2: 131,
    stroke: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 57.5,
    width: 110,
    height: 64,
    rx: 5.5,
    stroke: "#1A171B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M166 165.5H179.5C180.605 165.5 181.5 164.605 181.5 163.5V149L166 165.5Z",
    fill: "#97110C",
    stroke: "#97110C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 91.5,
    y: 70.5,
    width: 29,
    height: 23,
    stroke: "#1A171B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 145.5,
    y: 57.5,
    width: 27,
    height: 23,
    rx: 3.5,
    stroke: "#1A171B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 153.377,
    y1: 11.0665,
    x2: 154.419,
    y2: 11.0665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1919",
    stopOpacity: 0.257048
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1919",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 153.377,
    y1: 17.7825,
    x2: 154.419,
    y2: 17.7825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1919",
    stopOpacity: 0.260708
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1919",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 158.794,
    y1: 17.7825,
    x2: 157.752,
    y2: 17.7825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1919",
    stopOpacity: 0.260708
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1919",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildModule);
export default __webpack_public_path__ + "static/media/build-module.30bb25e56dd8347b344d5fc8e8633754.svg";
export { ForwardRef as ReactComponent };